"use client";

import { Github, Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuList() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        <li className="h-4 w-24 bg-muted animate-pulse rounded-md" />
        <li className="h-4 w-20 bg-muted animate-pulse rounded-md" />
        <li className="h-4 w-28 bg-muted animate-pulse rounded-md" />
        <li className="h-4 w-16 bg-muted animate-pulse rounded-md" />
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="text-sm text-foreground hover:text-primary transition-colors font-default inline-flex items-center gap-1.5 group">
            <span className="text-primary opacity-0 group-hover:opacity-100 transition-opacity font-mono text-xs">
              {">"}
            </span>
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const services = [{
  label: "iPhone Collection",
  href: "/iPhoneCollectionPage"
}, {
  label: "Android Collection",
  href: "/AndroidCollectionPage"
}, {
  label: "Trade-in & Repairs",
  href: "/TradeInRepairsPage"
}, {
  label: "Shop All",
  href: "/ShopPage"
}];
const legalLinks = [{
  label: "Privacy",
  href: "#"
}, {
  label: "Terms",
  href: "#"
}, {
  label: "Support",
  href: "#"
}];
export default function SiteFooter() {
  return <section data-section-id="4794" id="site-footer" className="dark bg-background text-foreground border-t border-border pt-32 pb-12 px-6 md:px-12 relative overflow-hidden">
      {}
      <div className="absolute top-6 left-6 font-mono text-[10px] text-muted-foreground tracking-widest">
        [ TECHWIRE.SYS / v.2024 ]
      </div>
      <div className="absolute top-6 right-6 font-mono text-[10px] text-primary tracking-widest">
        // END_OF_TRANSMISSION
      </div>

      <div className="max-w-7xl mx-auto">
        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          {}
          <div className="md:col-span-4 space-y-6">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-12 w-auto" />
            </Link>

            <p className="text-lg text-muted-foreground font-default leading-relaxed max-w-sm">
              Premium mobile technology, engineered for the modern user.
            </p>

            <div className="space-y-2 pt-2">
              <div className="font-mono text-xs text-primary tracking-wider">
                [ GLOBAL.DISTRIBUTION.HUB ]
              </div>
              <p className="text-[13px] text-muted-foreground font-default leading-relaxed">
                888 Digital Avenue
                <br />
                Tech City, CA 94043
              </p>
            </div>

            <div className="pt-2 space-y-1">
              <div className="font-mono text-[10px] text-muted-foreground tracking-widest uppercase">
                Store Hours
              </div>
              <div className="font-mono text-xs text-foreground">
                MON-SUN / 10:00 &mdash; 22:00
              </div>
            </div>
          </div>

          {}
          <div className="md:col-span-3 md:col-start-5">
            <div className="flex items-center gap-2 mb-6">
              <div className="h-px w-4 bg-primary" />
              <h3 className="font-default text-xs font-semibold tracking-widest uppercase text-foreground">
                Navigate
              </h3>
            </div>
            <MenuProvider menu_id="23">
              <FooterMenuList />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-3">
            <div className="flex items-center gap-2 mb-6">
              <div className="h-px w-4 bg-primary" />
              <h3 className="font-default text-xs font-semibold tracking-widest uppercase text-foreground">
                Categories
              </h3>
            </div>
            <ul className="space-y-3">
              {services.map((service, i) => <li data-index={i} key={service.label}>
                  <Link to={service.href} className="text-sm text-foreground hover:text-primary transition-colors font-default inline-flex items-center gap-1.5 group">
                    <span className="text-primary opacity-0 group-hover:opacity-100 transition-opacity font-mono text-xs">
                      {">"}
                    </span>
                    {service.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <div className="h-px w-4 bg-primary" />
              <h3 className="font-default text-xs font-semibold tracking-widest uppercase text-foreground">
                Connect
              </h3>
            </div>
            <ul className="space-y-3">
              <li>
                <Link to="#" newTab className="text-sm text-foreground hover:text-primary transition-colors font-default inline-flex items-center gap-2 group">
                  <Linkedin className="h-3.5 w-3.5" />
                  LinkedIn
                  <span className="text-primary text-xs">&#8599;</span>
                </Link>
              </li>
              <li>
                <Link to="#" newTab className="text-sm text-foreground hover:text-primary transition-colors font-default inline-flex items-center gap-2 group">
                  <Github className="h-3.5 w-3.5" />
                  GitHub
                  <span className="text-primary text-xs">&#8599;</span>
                </Link>
              </li>
              <li>
                <Link to="mailto:support@techwire.mobile" className="text-sm text-foreground hover:text-primary transition-colors font-mono inline-flex items-center gap-1.5 break-all">
                  support@techwire.mobile
                  <span className="text-primary text-xs">&#8599;</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {}
        <div className="mt-24 md:mt-32 relative">
          <div className="absolute -top-6 left-0 font-mono text-[10px] text-muted-foreground tracking-widest">
            // BRAND.SIGNATURE
          </div>
          <div aria-hidden="true" className="font-default font-bold text-center leading-none tracking-tighter select-none" style={{
          fontSize: "clamp(5rem, 22vw, 18rem)",
          WebkitTextStroke: "1px var(--primary)",
          color: "transparent"
        }}>
            TECHWIRE
          </div>
        </div>

        {}
        <div className="relative mt-8 mb-8">
          <Separator className="bg-border" />
          <div className="absolute inset-0 flex justify-between items-center pointer-events-none">
            {Array.from({
            length: 24
          }).map((_, i) => <div data-index={i} key={i} className="h-2 w-px bg-border" style={{
            marginTop: "-4px"
          }} />)}
          </div>
        </div>

        {}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 pt-4">
          <div className="font-mono text-xs text-muted-foreground tracking-wider">© 2026 TECHWIRE MOBILE / ALL RIGHTS RESERVED</div>

          <div className="flex items-center gap-2.5">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-primary opacity-75" />
              <span className="relative inline-flex rounded-lg h-2 w-2 bg-primary" />
            </span>
            <span className="font-mono text-xs text-foreground tracking-wider">
              SYSTEM ONLINE &mdash; READY FOR ORDERS
            </span>
          </div>

          <ul className="flex items-center gap-5">
            {legalLinks.map((link, i) => <li data-index={i} key={link.label}>
                <Link to={link.href} className="font-mono text-xs text-muted-foreground hover:text-primary transition-colors tracking-wider">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>

        {}
        <div className="flex justify-end mt-10">
          <span className="font-mono text-[10px] text-muted-foreground tracking-widest opacity-60">
            v.2024.11.03
          </span>
        </div>
      </div>
    </section>;
}